<template>
  <div id="app">
    <div class="el-frame">
      <el-container>
        <el-header v-if="show_header">
          <el-row style="height: 60px">
            <el-col :span="12">
              <el-image
                style="height: 50px; width: auto; margin-top: 5px"
                class="logo"
                v-if="logo_img != ''"
                :src="logo_img"
              >
              </el-image>
              &nbsp;
            </el-col>
            <el-col :span="12">
              <div class="header_i">
                <el-avatar
                  :size="40"
                  :src="circleUrl"
                  style="margin-top: 10px; margin-right: 10px"
                ></el-avatar>
                <div style="float: right; font-size: 16px">
                  {{ studentInfo.studentName }}
                </div>
              </div>
              <div class="header_i" @click="quit" title="退出">
                <i class="el-icon-switch-button"></i>
              </div>
              <div class="header_i" style="height: 30px">
                <el-badge :value="myMessageNum" :max="10" class="item">
                  <i class="el-icon-bell" @click="myNews" style="line-height: 25px"></i>
                </el-badge>
              </div>
              <div class="header_i" @click="home1">
                <i class="el-icon-search"></i>
              </div>
              <div class="header_i" @click="home" v-if="studentInfo.showType == 1">
                <i class="el-icon-s-home" style="font-size: 30px"></i>
                <div style="float: right; font-size: 16px">首页</div>
              </div>
            </el-col>
          </el-row>
        </el-header>
        <el-container class="bodyContainer">
          <el-aside
            width="260px"
            style="
              height: calc(100vh - 60px);
              overflow: auto;
              padding: 10px 0 10px 10px;
              background-color: #f3f3f3;
            "
            v-if="show_menu"
          >
            <!-- 菜单 -->
            <el-row class="menu_head"> 菜单栏 </el-row>
            <el-menu
              :default-active="active"
              class="el-menu-vertical-demo"
              @select="handSelect"
            >
                <!-- 接口查询的菜单存在时显示接口查询的菜单，否则显示默认菜单 -->
                <template v-if="studentMenuList.length > 0">
                    <template v-for="(item, index) in studentMenuList">
                        <!-- 存在下级 -->
                        <template v-if="item.childList.length > 0">
                            <el-submenu :index="index+''" :key="index+'studentMenuList'">
                              <template slot="title">
                                <span class="iconfont" v-if="item.studentMenuName == '教学计划'">&#xe71f;</span>
                                <span class="iconfont" v-if="item.studentMenuName == '学生信息'">&#xeb85;</span>
                                <span class="iconfont" v-if="item.studentMenuName == '学习中心'">&#xe63d;</span>
                                <span class="iconfont" v-if="item.studentMenuName == '毕业论文' || item.studentMenuName == '成教论文'">&#xe759;</span>
                                <span>{{item.studentMenuShowName}}</span>
                              </template>
                              <el-menu-item-group>
                                  <template v-for="(it, ind) in item.childList">
                                      <el-menu-item :index="index+'-'+ind" :key="index+'-'+ind+'childList'">{{it.studentMenuShowName}}</el-menu-item>
                                  </template>
                                  <template v-if="item.studentMenuName == '学生信息'">
                                      <template v-for="(item, index) in templateMenuList">
                                        <el-menu-item
                                          :key="index + 'templateMenuListKey'"
                                          :index="'11-' + (index + 8)"
                                        >
                                          {{ item.templateName }}
                                        </el-menu-item>
                                      </template>
                                  </template>
                              </el-menu-item-group>
                            </el-submenu>
                        </template>
                        <!-- 不存在下级 -->
                        <template v-else>
                            <el-menu-item :index="index+''" :key="index+'studentMenuList'">
                                <span class="iconfont"
                                    v-if="item.studentMenuName == '录取通知书' ||
                                    item.studentMenuName == '新生报到'"
                                >&#xe716;</span>
                                <span class="iconfont" v-if="item.studentMenuName == '我的消息'">&#xe667;</span>
                                <span class="iconfont" v-if="item.studentMenuName == '报到材料'">&#xe661;</span>
                                <span class="iconfont" v-if="item.studentMenuName == '补考安排'">&#xe64b;</span>
                                <span class="iconfont" v-if="item.studentMenuName == '成绩查询'">&#xe629;</span>
                                <span class="iconfont" v-if="item.studentMenuName == '通知公告'">&#xe607;</span>
                                <span class="iconfont" v-if="item.studentMenuName == '问卷调查' || item.studentMenuName == '教师评价'">&#xe60d;</span>
                                <i class="iconfont frontLive" v-if="item.studentMenuName == '课程直播'"></i>
                                <i class="iconfont myMoney" v-if="item.studentMenuName == '我的财务'"></i>
                                <span slot="title">
                                    <template v-if="item.studentMenuName == '问卷调查'">
                                        <template v-if="surveyMessageNum > 0">
                                          <el-badge
                                            :value="surveyMessageNum"
                                            :max="10"
                                            style="line-height: 25px; width: 75px"
                                          >
                                            问卷调查
                                          </el-badge>
                                        </template>
                                        <template v-else> 问卷调查 </template>
                                    </template>
                                    <template v-else-if="item.studentMenuName == '教师评价'">
                                        <template v-if="teaEvaluateMessageNum > 0">
                                          <el-badge
                                            :value="teaEvaluateMessageNum"
                                            :max="10"
                                            style="line-height: 25px; width: 75px"
                                          >
                                            教师评价
                                          </el-badge>
                                        </template>
                                        <template v-else> 教师评价 </template>
                                    </template>
                                    <template v-else>
                                        {{item.studentMenuShowName}}
                                    </template>
                                </span>
                            </el-menu-item>
                        </template>
                    </template>
                </template>
                <template v-else>
                    <template v-if="studentInfo.showType == 2">
                        <template v-for="(item, index) in templateMenuList">
                          <el-menu-item
                            :key="index + 'templateMenuListKey'"
                            :index="'11-' + (index + 8)"
                          >
                              <span class="iconfont">&#xe716;</span>
                            {{ item.templateName }}
                          </el-menu-item>
                        </template>
                      <!-- <el-menu-item index="1" v-if="!this.$strExistHostnameOnce(['czys'])">
                        <span class="iconfont">&#xe716;</span>
                        <span slot="title">录取通知书</span>
                      </el-menu-item> -->
                      <el-menu-item index="13" v-if="isShowNewMenu">
                        <span class="iconfont">&#xe716;</span>
                        <span slot="title">新生报到</span>
                      </el-menu-item>

                        <el-menu-item index="11-1" v-if="$strExistHostnameOnce(['xttc','localhost'])">
                            <span class="iconfont">&#xe716;</span>
                            <span slot="title">个人信息</span>
                        </el-menu-item>

                      <el-menu-item
                        v-if="this.$strExistHostnameOnce(['czvtc', 'hbsi', 'sjzpt'])"
                        index="11-6"
                      >
                        <span class="iconfont">&#xe667;</span>
                        <span slot="title">我的消息</span>
                      </el-menu-item>
                    </template>

                    <template v-if="studentInfo.showType == 1">
                      <el-menu-item index="2" v-if="checkInShow">
                        <span class="iconfont">&#xe661;</span>
                        <span slot="title">报到材料</span>
                      </el-menu-item>
                      <!-- <el-submenu index="3" v-if="!this.$strExistHostnameOnce(['lfjtysxx','xttc','hbsi','bvtc','hbjd','lfyjzjxy','sjzgsxy','hsnc','sjzpt'])">
                                          <template slot="title">
                                              <span class="iconfont">&#xe60f;</span>
                                              <span>在线缴费</span>
                                          </template>
                                          <el-menu-item-group>
                                              <el-menu-item index="3-1">在线缴费</el-menu-item>
                                              <el-menu-item index="3-2">费用查询</el-menu-item>
                                              <el-menu-item index="3-3">缴费凭证上传</el-menu-item>
                                          </el-menu-item-group>
                                      </el-submenu> -->
                        <template v-if="!this.$strExistHostnameOnce(['hbjz'])">
                            <el-submenu
                              index="4"
                              v-if="$gradeNotShow(['hbafajj'])"
                            >
                              <template slot="title">
                                <span class="iconfont">&#xe71f;</span>
                                <span>教学计划</span>
                              </template>
                              <el-menu-item-group>
                                <el-menu-item index="4-1">课表查询</el-menu-item>
                                <el-menu-item index="4-2">教学计划</el-menu-item>
                                <el-menu-item
                                  index="4-3"
                                  v-if="
                                    this.$strExistHostnameOnce([
                                      'localhost',
                                      'jjykt',
                                      'hbsi',
                                      'sjzpt',
                                    ])
                                  "
                                  >选课中心</el-menu-item
                                >
                              </el-menu-item-group>
                            </el-submenu>
                        </template>

                      <!-- <el-menu-item index="5">
                                          <span class="iconfont">&#xe60d;</span>
                                          <span slot="title">选课中心</span>
                                      </el-menu-item> -->
                      <el-submenu index="6">
                        <template slot="title">
                          <span class="iconfont">&#xe63d;</span>
                          <span>学习中心</span>
                        </template>
                        <el-menu-item-group>
                          <el-menu-item index="6-1">在线学习</el-menu-item>
                          <!-- <el-menu-item index="6-2">直播课</el-menu-item> -->
                        </el-menu-item-group>
                      </el-submenu>
                      <el-menu-item index="7">
                        <span class="iconfont">&#xe64b;</span>
                        <span slot="title">补考安排</span>
                      </el-menu-item>
                      <!-- !this.$strExistHostnameOnce([
                        'lfjtysxx',
                        'xttc',
                        'bvtc',
                        'hbjd',
                        'lfyjzjxy',
                        'sjzgsxy',
                        'hsnc',
                        'hdc',
                        'hbsi',
                        'sjzpt',
                        'nciae',
                      ]) -->
                      <el-submenu
                        index="8"
                        v-if="false"
                      >
                        <template slot="title">
                          <span class="iconfont">&#xe759;</span>
                          <span>毕业{{$getShowName()}}</span>
                        </template>
                        <el-menu-item-group>
                          <!-- <el-menu-item index="8-1">论文指导老师</el-menu-item>
                                              <el-menu-item index="8-2">论文题目设置</el-menu-item>
                                              <el-menu-item index="8-3">论文要求查看</el-menu-item>
                                              <el-menu-item index="8-4">论文上传</el-menu-item>
                                              <el-menu-item index="8-5">论文成绩查询</el-menu-item> -->
                          <el-menu-item index="8-6">我的{{$getShowName()}}</el-menu-item>
                        </el-menu-item-group>
                      </el-submenu>
                      <el-menu-item index="9" v-if="$gradeNotShow(['hbafajj'])">
                        <span class="iconfont">&#xe629;</span>
                        <span slot="title">成绩查询</span>
                      </el-menu-item>
                      <!-- <el-menu-item index="10">
                                          <span class="iconfont">&#xe612;</span>
                                          <span slot="title">资料下载</span>
                                      </el-menu-item> -->
                      <el-submenu index="11">
                        <template slot="title">
                          <span class="iconfont">&#xeb85;</span>
                          <span>学生信息</span>
                        </template>
                        <el-menu-item-group>
                          <el-menu-item index="11-1">个人信息</el-menu-item>
                          <!-- <el-menu-item index="11-2" v-if="!this.$strExistHostnameOnce(['lfjtysxx','bvtc','hbjd','lfyjzjxy','sjzgsxy','hsnc','hbsi','sjzpt'])">学籍卡</el-menu-item> -->
                          <!-- <el-menu-item index="11-3">毕业生登记表</el-menu-item> -->
                          <template v-for="(item, index) in templateMenuList">
                            <el-menu-item
                              :key="index + 'templateMenuListKey'"
                              :index="'11-' + (index + 8)"
                            >
                              {{ item.templateName }}
                            </el-menu-item>
                          </template>
                          <template v-if="!$strExistHostnameOnce(['hsnc','sjzzj','jlaudev'])">
                              <el-menu-item index="11-4">学籍照片上传</el-menu-item>
                              <el-menu-item index="11-5" v-if="!$strExistHostnameOnce(['nciae'])">毕业照片上传</el-menu-item>
                          </template>
                          <el-menu-item index="11-6">我的消息</el-menu-item>
                          <el-menu-item index="11-7">修改密码</el-menu-item>
                        </el-menu-item-group>
                      </el-submenu>
                      <el-menu-item index="12">
                        <span class="iconfont">&#xe607;</span>
                        <span slot="title">通知公告</span>
                      </el-menu-item>
                      <el-menu-item
                        index="15"
                        v-if="
                          this.$strExistHostnameOnce(['localhost', 'jjykt', 'hbsi', 'sjzpt','hbkjxy'])
                        "
                      >
                        <span class="iconfont">&#xe60d;</span>
                        <span slot="title">
                          <template v-if="surveyMessageNum > 0">
                            <el-badge
                              :value="surveyMessageNum"
                              :max="10"
                              style="line-height: 25px; width: 75px"
                            >
                              问卷调查
                            </el-badge>
                          </template>
                          <template v-else> 问卷调查 </template>
                        </span>
                      </el-menu-item>
                      <el-menu-item
                        index="16"
                        v-if="
                          this.$strExistHostnameOnce(['localhost', 'jjykt', 'hbsi', 'sjzpt','hbwgy'])
                        "
                      >
                        <span class="iconfont">&#xe60d;</span>
                        <span slot="title">
                          <template v-if="teaEvaluateMessageNum > 0">
                            <el-badge
                              :value="teaEvaluateMessageNum"
                              :max="10"
                              style="line-height: 25px; width: 75px"
                            >
                              教师评价
                            </el-badge>
                          </template>
                          <template v-else> 教师评价 </template>
                        </span>
                      </el-menu-item>
                      <el-menu-item
                        index="14"
                      >
<!--                          v-if="-->
<!--                          this.$strExistHostnameOnce([-->
<!--                          'localhost',-->
<!--                          'bvtc',-->
<!--                          'jjykt',-->
<!--                          'hbsi',-->
<!--                          'sjzpt',-->
<!--                          'sjzzj',-->
<!--                          'hbwgy',-->
<!--                          'hbjd'-->
<!--                          ])-->
<!--                          "-->
                        <!-- <span class="iconfont">&#xe607;</span> -->
                        <i class="iconfont frontLive"></i>
                        <span slot="title">课程直播</span>
                      </el-menu-item>
                      <el-menu-item index="17" v-if="myFinanceShow">
                        <!-- <span class="iconfont">&#xe607;</span> -->
                        <i class="iconfont myMoney"></i>
                        <span slot="title">我的财务</span>
                      </el-menu-item>
                      <el-menu-item index="19" v-if="showStatusChange">
                        <span class="iconfont">&#xe63d;</span>
                        <span slot="title">学籍异动</span>
                      </el-menu-item>
                      <!-- 成人论文 -->
                      <el-submenu index="18">
                        <template slot="title">
                          <span class="iconfont">&#xe759;</span>
                          <span>毕业{{$getShowName()}}</span>
                        </template>
                        <el-menu-item-group>
                          <el-menu-item index="18-1">{{$getShowName()}}要求</el-menu-item>
                          <el-menu-item index="18-2">{{$getShowName()}}报名</el-menu-item>
                          <el-menu-item index="18-3">{{$getShowName()}}写作</el-menu-item>

                         <!-- <el-menu-item index="18-4" v-if="$getShowName() == '论文'">万信{{$getShowName()}}查重</el-menu-item>-->

                          <!-- <el-menu-item index="18-4" v-if="$getShowName() == '论文'">万信{{$getShowName()}}查重</el-menu-item> -->

<!--                          <el-menu-item index="18-4" v-if="$getShowName() == '论文' && this.$strExistHostnameOnce(['hbwgy'])">万信{{$getShowName()}}查重</el-menu-item>-->

                          <el-menu-item index="18-5" v-if="$getShowName() == '论文' && this.$strExistHostnameOnce(['localhost', 'hevttc','hbwgy'])">维普{{$getShowName()}}查重</el-menu-item>
                        </el-menu-item-group>
                      </el-submenu>
                    </template>
                </template>
                <el-menu-item index="20" v-if="
                  this.$strExistHostnameOnce(['localhost', 'hebuee','hevttc'])
                ">
                  <span class="iconfont">&#xe6f0;</span>
                  <span slot="title">论文AI评审</span>
                </el-menu-item>

                <el-menu-item index="21" v-if="this.$strExistHostnameOnce(['localhost', 'hevttc'])">
                  <span class="iconfont">&#xe6f0;</span>
                  <span slot="title">请假申请</span>
                </el-menu-item>
                <el-menu-item index="22" v-if="this.$strExistHostnameOnce(['localhost', 'hevttc'])">
                  <span class="iconfont">&#xeb85;</span>
                  <span slot="title">任务分组</span>
                </el-menu-item>
            </el-menu>
          </el-aside>
          <el-main v-if="studentInfo.showType != 3">
            <!-- 内容页面 -->
            <router-view />
          </el-main>
        </el-container>
      </el-container>
    </div>
    <newIndex></newIndex>
    <newStudentSMS v-if="newStudentSMSShow"></newStudentSMS>
    <loginSMS v-if="loginSMSShow" :studentForm="studentForm"></loginSMS>
    <studentPay v-if="showStudentPay"></studentPay>
  </div>
</template>

<script>
import {
  getCookieForRoleTag,
  getCookieKeyForRoleTag,
  getStorageKeyForRoleTag,
  getStudentInfoKeyForRoleTag,
  strExistHostnameOnce,
} from "./common/ulit";
import menuRouteMap from "@/common/menu.js"; //菜单对应的路由
import newIndex from "@/components/newIndex"; //消息强制提示
import newStudentSMS from "@/components/newStudentSMS"; //新生短信验证
import loginSMS from "@/components/loginSMS"; //登陆后短信验证
import studentPay from "@/components/studentPay"; //在籍生付款
export default {
  components: {
    newIndex,
    newStudentSMS,
    loginSMS,
    studentPay,
  },
  name: "App",
  data() {
    return {
      myMessageNum: 0,
      studentInfo: { showType: 3 }, //学生信息 showType 展示内容 1在籍学生的 2新生的
      show_header: this.$route.meta.headerShow, //控制头部是否显示
      show_menu: this.$route.meta.menuShow, //控制左侧菜单是否显示
      logo_img: "",
      active: "", //菜单默认展示的位置
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      menuList: {
        //相应菜单对应的路由器
        1: "LetterAdmission", //录取通知书
        2: "CheckInMaterials", //报到材料
        "3-1": "Pay", //在线缴费
        "3-2": "ExpenseQuery", //费用查询
        "3-3": "Voucher", //缴费凭证上传
        "4-1": "TimetableQuery", //课表查询
        "4-2": "TeachingPlan", //教学计划
        "4-3": "CourseSelectionCenter", //选课中心
        5: "CourseSelection", //选课中心
        "6-1": "OnlineLearning", //在线学习
        "6-2": "LiveClass", //直播课
        7: "MakeUpExam", //补考安排
        "8-1": "Instructor", //论文指导老师
        "8-2": "TopicSetting", //论文题目设置
        "8-3": "Require", //论文要求查看
        "8-4": "PaperUpload", //论文上传
        "8-5": "PaperScoreQuery", //论文成绩查询
        "8-6": "UserPaper", //我的论文
        9: "ScoreQuery", //成绩查询
        10: "DataDownload", //资料下载
        "11-1": "UserInfo", //个人信息
        "11-2": "StudentCard", //学籍卡
        "11-3": "RegistrationForm", //毕业生登记表
        "11-4": "StudentPhoto", //学籍照片上传
        "11-5": "GraduatePhoto", //毕业照片上传
        "11-6": "MyNews", //我的消息
        "11-7": "EditPassword", //修改密码
        12: "Notice", //通知公告
        13: "StudentReport", //新生报道
        14: "LivePlan", //课程直播
        15: "QuestionnaireList", //问卷调查
        16: "TeacherEvaluateList", //教师评价
        17: "MyFinances", //我的财务
        "18-1": "ask", //成交论文要求
        "18-2": "application", //成交论文报名
        "18-3": "write", //成交论文写作
        "18-4": "check", //成交论文查重
        "18-5":"duplicateCheck",
        19: "stuStatusChangeApply", //学籍异动
        20: "reviewArticle", //论文AI评审
        21: "leaveApply", //请假申请
        22: "taskGrouping", //任务分组
      },
      teaEvaluateMessageNum: 0, //教师评价未填数
      // templateMenuList: window.getTemplateMenuList || [], //附加菜单
      templateMenuList: [], //附加菜单
      surveyMessageNum: 0, //调查问卷未填数
      showLoginPage_development: process.env.NODE_ENV === "development", //process.env.NODE_ENV==="development"
      newStudentSMSShow: false, //是否显示新生短信验证信息
      isShowNewMenu: false, //是否显示新生报到页面
      checkInShow: false, //是否显示报到菜单（仅仅在籍生使用）
      myFinanceShow: false, //是否显示我的财务菜单（仅仅在籍生使用）
      showStatusChange: false, //是否显示自主异动学籍功能（仅仅在籍生使用）
      studentMenuList:[], //学生菜单
      loginSMSShow:false, //是否显示登录后短信验证
      studentForm:{
          studentName:"",
          studentIdCard: "",
          studentPhone: "",
          yzm: ""
      },
      showStudentPay:false
    };
  },
  computed: {
    getCurrentSchoolName() {
      return window.getCurrentSchoolName();
    },
  },
  created() {
    this.getStudentMenuList();
    for (let i in this.templateMenuList) {
      this.menuList["11-" + (Number(i) + 8)] = "TemplateInfo";
    }
    window.baiduCount(); //加载百度统计js
    this.active = this.findkey(this.menuList, this.$route.path.replace("/", ""));
    this.getStudentInfo(); //获取学生信息
    sessionStorage.removeItem(getStorageKeyForRoleTag("videoLoading"));
    // this.$uploadCourselog(); //执行视频记录上传
    if (process.env.NODE_ENV === "development") {
      //开发环境
      this.studentInfo.showType = 1;
    }
  },
  methods: {
    getStudentMenuList(){ //获取菜单信息
        if(!this.$isEmpty(getCookieForRoleTag())) {
            this.$store.dispatch("user/getStudentMenuList").then((ret) => {
                if(ret.code == 0) {
                    this.studentMenuList = ret.data;
                }
            });
            this.listShowTemplate();
        }

    },
    listShowTemplate(){ //获取模板菜单信息
        let templateList = JSON.parse(sessionStorage.getItem(getStorageKeyForRoleTag('templateList')));
        if(this.$isEmpty(templateList)){
            this.$store.dispatch("user/listShowTemplate").then((ret) => {
                if(ret.code == 0) {
                    this.templateMenuList = ret.data;

                    // this.templateMenuList = [
                    //     {
                    //         templateId:1,
                    //         templateName:"学籍卡",
                    //         type: 1,//类型 1 展示  2 可编辑
                    //         templateType:2 //类型（1图片模板 2表格模板）
                    //     },
                    //     {
                    //         templateId:1,
                    //         templateName:"毕业生登记表",
                    //         type: 1,//类型 1 展示  2 可编辑
                    //         templateType:2 //类型（1图片模板 2表格模板）
                    //     },
                    //     {
                    //         templateId:1,
                    //         templateName:"录取通知书",
                    //         type: 1,//类型 1 展示  2 可编辑
                    //         templateType:2 //类型（1图片模板 2表格模板）
                    //     },
                    // ];
                    sessionStorage.setItem(getStorageKeyForRoleTag('templateList'),JSON.stringify(this.templateMenuList));
                }
            });
        }else{
            this.templateMenuList = templateList;
        }

    },
    home() {
      this.show_menu = true;
      this.$router.push({ name: "Home" });
    },
    myNews() {
      this.show_menu = true;
      this.$router.push({ name: "MyNews" });
    },
    quit() {
      //退出
      this.$confirm("是否确定退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("user/logout").then((ret) => {
            if (ret.code === 0 || ret.code === "0") {
              this.$message({
                message: "退出成功！",
                type: "success",
                onClose: () => {
                  this.$cookies.remove(getCookieKeyForRoleTag());
                  window.location.href =
                    process.env.NODE_ENV === "development"
                      ? "/login"
                      : this.$baseUrl + "/login";
                  // localStorage.removeItem('TOKEN');
                  //window.location.href = window.location.origin + '/Login';
                },
              });
            } else {
              this.$message({
                message: ret.msg,
                type: "warning",
              });
            }
          });
        })
        .catch(() => {});
    },
    home1() {
      this.show_menu = true;
      this.$router.push({ name: "IndexHtml" });
    },
    handSelect(key, keyPath) {
      if(key == 21){
        console.log(this.menuList[key]);
        this.$router.push({ name: 'leaveApply' });
      }
        if(this.studentMenuList.length <= 0){
            if (key.indexOf("11-") >= 0 && Number(key.split("-")[1]) >= 8) {
              //表示是js文件自己加的
              this.$router.push({
                name: 'TemplateInfo',
                query: {
                    menuIndex: window.btoa(Number(key.split("-")[1] - 8)) ,
                    templateName: this.templateMenuList[Number(key.split("-")[1] - 8)].templateName
                },
              });
            } else {
              this.$router.push({ name: this.menuList[key] });
            }
        }else{
            if (key.indexOf("11-") >= 0 && Number(key.split("-")[1]) >= 8) {
              //表示是js文件自己加的
              this.$router.push({
                name: 'TemplateInfo',
                query: {
                    menuIndex: window.btoa(Number(key.split("-")[1] - 8)) ,
                    templateName: this.templateMenuList[Number(key.split("-")[1] - 8)].templateName
                },
              });
            }else{
                const keyArray = key.split("-");
                let routerName = "",studentMenuName = "";
                if(keyArray.length == 1){
                    studentMenuName = this.studentMenuList[keyArray[0]].studentMenuName;
                }else if(keyArray.length > 1){
                    studentMenuName = this.studentMenuList[keyArray[0]].childList[keyArray[1]].studentMenuName;
                }
                routerName = menuRouteMap[studentMenuName];
                this.$router.push({ name: routerName,query:{templateName:studentMenuName}});
            }
        }
    },
    findkey(obj, value, fn = (a, b) => a === b) {
      //根据值获取键
      let valInfo =
        value.substring(0, 1).toUpperCase() + value.substring(1, value.length);
      let v = Object.keys(obj).find((k) => fn(obj[k], valInfo));
      if (valInfo == "TemplateInfo") {
        //证明是自己定义的模板菜单
        var menuIndex = window.atob(this.$route.query.menuIndex); //拿到当前位置
        v = "11-" + (Number(menuIndex) + 8);
      }
      return v;
    },
    getStudentInfo() {
      if (!this.$isEmpty(getCookieForRoleTag())) {
        this.$store.dispatch("user/getStudentInfo").then((ret) => {
          if (ret.code === 0 || ret.code === "0") {
            document.title = ret.data.systemName; //设置头
            this.logo_img = this.$baseUrl + ret.data.systemLogo;
            this.studentInfo = ret.data;
            sessionStorage.setItem(
              getStudentInfoKeyForRoleTag(),
              JSON.stringify(ret.data)
            ); //将学生信息存入缓存
            this.getMyMessageNum(); //获取未读消息数量
            if (this.studentInfo.showType == 2) { //showType:展示内容 1在籍学生的 2新生的
              //新生
              this.newStudentSMSShow = true;
              this.getStudentReportShowConfig(); //查询是否显示新生报到

              // if (this.$strExistHostnameOnce(["czvtc", "hbsi", "sjzpt",'czys'])) {
              //   this.$router.push({ name: "StudentReport" });
              // } else {
              //     this.$router.push({ //录取通知书
              //       name: 'TemplateInfo',
              //       query: { menuIndex: window.btoa(2),templateName:'录取通知书' },
              //   });
              //   // this.$router.push({ name: "TemplateInfo" });
              // }
            } else {
                if(ret.data.beforeStudyVerifyPhone == 1){ // 学习前是否需要验证手机 1是 2否
                    this.loginSMSShow = true;
                    this.studentForm.studentName = ret.data.studentName || "";
                    this.studentForm.studentIdCard = ret.data.studentIdCard || "";
                    this.studentForm.studentPhone = ret.data.studentPhone || "";
                }
                this.showStudentPay = true;
              this.getSurveyMessageNum(); //获取未填调查问卷数
              this.getTeaEvaluateMessageNum(); //获取未填教师评价数
              this.getRegistrationMaterialsOpenConfig(); //查询是否显示报到材料菜单
              this.getMyFinanceOpenConfig(); //查询是否显示我的财务菜单
              this.isShowStatusChange(); //是否显示自主异动学籍功能
            }
          }
        });
      }
    },
    getMyMessageNum() {
      if (!this.$isEmpty(getCookieForRoleTag())) {
        this.$store.dispatch("user/getMyMessageNum").then((ret) => {
          if (ret.code === 0 || ret.code === "0") {
            this.myMessageNum = ret.data;
            if (this.myMessageNum > 0) {
              this.$notify({
                title: "您有消息未读",
                position: "bottom-right",
                type: "warning",
                customClass: "newClass",
                message: "立即查看",
                onClick: () => {
                  this.$notify.closeAll();
                  this.myNews();
                },
              });
            }
          }
        });
      }
    },
    getSurveyMessageNum() {
      //获取未填调查问卷数
      if (!this.$isEmpty(getCookieForRoleTag())) {
        this.$store.dispatch("user/getSurveyMessageNum").then((ret) => {
          if (ret.code === 0 || ret.code === "0") {
            this.surveyMessageNum = ret.data;
          }
        });
      }
    },
    getTeaEvaluateMessageNum() {
      //获取未填教师评价数
      if (!this.$isEmpty(getCookieForRoleTag())) {
        this.$store.dispatch("user/getTeaEvaluateMessageNum").then((ret) => {
          if (ret.code === 0 || ret.code === "0") {
            this.teaEvaluateMessageNum = ret.data;
          }
        });
      }
    },
    getStudentReportShowConfig() {
      //新生报到菜单是否显示
      if (!this.$isEmpty(getCookieForRoleTag())) {
        this.$store.dispatch("user/getStudentReportShowConfig").then((ret) => {
          if (ret.code === 0 || ret.code === "0") {
            this.isShowNewMenu = ret.data;

          }
        }).finally(()=>{
            if(this.studentMenuList.length <= 0 && this.templateMenuList.length > 0){
                this.$router.push({ //录取通知书
                  name: 'TemplateInfo',
                  query: { menuIndex: window.btoa(2),templateName:this.templateMenuList[0].templateName },
                });
                this.active = '11-8';
            }else{
                if(this.isShowNewMenu){
                    this.$router.push({ name: "StudentReport" });
                    this.active = '13';
                }else{
                    this.$router.push({ name: "MyNews" });
                }
            }
        });
      }
    },
    getRegistrationMaterialsOpenConfig() {
      //查询是否显示报到材料菜单
      this.$store.dispatch("user/getRegistrationMaterialsOpenConfig").then((ret) => {
        if (ret.code == 0) {
          this.checkInShow = ret.data;
        }
      });
    },
    getMyFinanceOpenConfig() {
      //查询是否显示报到材料菜单
      this.$store.dispatch("user/getMyFinanceOpenConfig").then((ret) => {
        if (ret.code == 0) {
          this.myFinanceShow = ret.data;
        }
      });
    },
    isShowStatusChange() {
      //是否显示自主异动学籍功能
      this.$store.dispatch("user/isShowStatusChange").then((ret) => {
        if (ret.code == 0) {
          // this.showStatusChange = true;
          this.showStatusChange = ret.data;
        }
      });
    }
  },
  beforeCreate() {
    //五分钟跑一次，如果离开页面则重新计算时间，执行this.$getClientNeedStudyLog()方法中做了一小时限制
    // console.log("开始了定时执行对比课程任务！");
    // this.timeoutInfo = setInterval(() => {
    //   this.$getClientNeedStudyLog();
    // }, 1 * 60 * 1000); //50 * 60 * 1000
  },
};
</script>

<style lang="less">
@import "static/iconfont/iconfont.css";
@import "styles/style.less";
@import "styles/base.less";

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.newClass {
  .el-notification__content {
    text-align: right;
    width: 230px;

    p {
      color: #409eff;
      cursor: pointer;
    }
  }
}
.el-notification{
    width: auto;
}
.superintendentDataClass{
    width: auto !important;
    max-height: calc(100vh - 100px);
    background-image: url('images/update-img.png');
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: 0px -32px;
    overflow: auto;
    padding-right:0 !important;
    .el-notification__title{
        height: 160px !important;
    }
    .el-notification__content {
        width: 400px !important;
        max-height: 500px;
        overflow: auto;
    }
    .el-notification__closeBtn{
        color: white !important;
    }
}

.el-header,
.el-footer {
  background-color: @bgZS;
  line-height: 60px;

  .logo img {
    width: auto;
  }

  .header_i {
    float: right;
    height: 60px;
    color: white;
    padding: 0 20px;
    font-size: 20px;
    cursor: pointer;

    i {
      font-size: 20px;
      float: left;
      line-height: 57px;
    }
  }
}

.bodyContainer {
  .el-menu-vertical-demo {
    height: calc(100vh - 142px);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    overflow: auto;
    border-right: none;
    background-color: @bgZS;
  }

  .el-submenu__title:hover,
  .el-menu-item:focus,
  .el-menu-item:hover {
    background-color: #56b9cf !important;
  }

  .el-submenu__title i {
    color: white !important;
  }

  .el-menu-vertical-demo::-webkit-scrollbar {
    display: none;
  }

  .menu_head {
    text-align: center;
    color: white;
    background-color: @bgZS;
    padding: 18px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin-bottom: 5px;
  }
}

.el-aside::-webkit-scrollbar {
  display: none;
}

.el-main {
  background-color: @mainBg !important;
  min-width: 800px;
  // height: calc(100vh - 80px);
  // overflow: auto;
  padding: 10px !important;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.odyContainer {
  height: calc(100vh - 77px);
}

//右侧页面下拉隐藏
.page_content::-webkit-scrollbar {
  display: none;
}

.el-menu-item-group__title {
  padding: 0;
}

.el-menu-item,
.el-submenu__title {
  font-size: 17px;
  border-bottom: 1px solid #93b5f5 !important;
  color: white !important;
}

.el-menu-item.is-active {
  color: white;
  background-color: #56b9cf;
}

.el-submenu .el-menu-item {
  padding-left: 60px !important;
  height: 56px;
  line-height: 56px;
}

.iconfont {
  margin: 0 5px;
  width: 24px;
  text-align: center;
  font-size: 24px;
  vertical-align: middle;
}

.el-aside {
  .el-menu {
    background-color: @bgZS;

    .el-menu-item {
      height: 50px;
      line-height: 50px;
    }
  }
}
</style>

<style lang="less">
.customIcon() {
  background-size: cover;
  background-repeat: no-repeat;
  font-weight: lighter;
  margin: 0 5px;
  display: inline-block;
  width: 24px !important;
  height: 24px !important;
  line-height: 1;
  text-align: center;
  font-size: 24px;
  vertical-align: middle;
  transform: translateY(-2px);
}

.frontLive {
  background: url("./images/live.png");
  .customIcon();
}

.myMoney {
  background: url("./images/money.png");
  .customIcon();
}
</style>



// WEBPACK FOOTER //
// src/App.vue